<tidy-form-popup
  [isOpen]="isNotePopupOpen"
  [formType]="'input'"
  [label]="'Job Note'"
  [placeholder]="'Ex: Please put away the laundry downstairs.'"
  [icon]="'assets/svg/information-circle-outline.svg'"
  [initialValue]="existingNoteText"
  [saveAction]="onNoteSave"
  (cancelAction)="onNoteCancel()" />

<tidy-form-popup
  [isOpen]="isChecklistPopupOpen"
  [formType]="'select'"
  [label]="'Checklist'"
  [icon]="'assets/svg/list-outline.svg'"
  [items]="checklistItems"
  [initialValue]="currentChecklistId"
  [saveAction]="onChecklistSave"
  (cancelAction)="onChecklistCancel()" />

<tidy-form-popup
  [isOpen]="isCustomFieldPopupOpen"
  [formType]="'input'"
  [label]="editingCustomField?.name"
  [initialValue]="editingCustomField?.value !== 'N/A' ? editingCustomField?.value : ''"
  [saveAction]="onCustomFieldSave"
  (cancelAction)="onCustomFieldCancel()" />

<tidy-form-popup
  [isOpen]="showChangeProPopup"
  [formType]="'custom'"
  [header]="changeProHeaderText + (' Pro' | translate)"
  [saveText]="changeProSubmitText"
  [saveAction]="boundConfirmChangePro"
  (cancelAction)="closeChangeProPopup()">
  @if (changeProForm) {
    <form [formGroup]="changeProForm">
      <tidy-row class="extra-bottom-padding">
        <tidy-radio-button
          [label]="'What do you want to do?'"
          formControlName="existingOrNew"
          [form]="changeProForm.controls.existingOrNew"
          (optionChange)="onChangeProTypeSelect($event)"
          [items]="changeProExistingOrNewItems" />
      </tidy-row>
      @if (changeProForm?.value?.existingOrNew === 'existingPro') {
        <tidy-row>
          <tidy-select
            [label]="'Select Pro'"
            formControlName="privatePro"
            [form]="changeProForm.controls.privatePro"
            [items]="changeProPrivateProItems"
            [icon]="'assets/svg/person.svg'" />
        </tidy-row>
      }
      @if (changeProForm?.value?.existingOrNew === 'newPro') {
        <tidy-row class="field-bottom-padding">
          <tidy-input
            [label]="'Their Name*'"
            formControlName="name"
            [form]="changeProForm.controls.name"
            [submitted]="changeProSubmitted"
            [errorMessage]="'Please enter a name.'"
            [icon]="'assets/svg/person.svg'" />
        </tidy-row>
        <tidy-row class="field-bottom-padding">
          <tidy-input
            [label]="'Their Email*'"
            formControlName="email"
            [form]="changeProForm.controls.email"
            type="email"
            [submitted]="changeProSubmitted"
            [errorMessage]="'Please enter a valid email.'"
            [icon]="'assets/svg/mail.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-input-international-phone
            [label]="'Their Phone'"
            formControlName="phone"
            [form]="changeProForm.controls.phone"
            [inputMode]="'numeric'"
            [submitted]="changeProSubmitted"
            [errorMessage]="'Please enter a valid phone.'"
            [icon]="'assets/svg/phone-portrait.svg'"
            [initialMask]="{ mask: '[00000000000000000000000]' }"
            (countryCodeChange)="onChangeProCountryCodeChange($event)" />
        </tidy-row>
      }
      @if (changeProErrorMessage) {
        <tidy-error-message
          [text]="changeProErrorMessage" />
      }
    </form>
  }
</tidy-form-popup>
